import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ManageTeamsTable = lazy(() =>
  import("../../../../../app-settings").then((module) => ({ default: module.default.ManageTeamsTable }))
);

export const internalTeamsNRO: NavigationRoutingObject = {
  Component: ManageTeamsTable,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("internal-teams-pill-menu-option", "Internal Teams"),
  pageNameForTracking: () => "Internal Teams",
  section: "settings",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    const canViewTeams = featureOn("territories_v2")
      ? hasPermission("appGroup", { permission: "viewTeams" })
      : true;
    return featureOn("territories") && canViewTeams;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("manage-teams-settings", "Manage Teams")],
      description: t("previously-manage-teams", 'Previously "Manage Teams"'),
    },
    {
      keywords: [t("email-preferences-manage-settings", "Manage Settings")],
      description: t("previously-manage-settings", 'Previously in "Manage Settings"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
